let scrollToComponent = () => {}; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  scrollToComponent = require('react-scroll-to-component');
}

export default scrollToComponent;
